import { h as i } from "vue";
const m = (a, s) => {
  const r = "http://www.w3.org/2000/svg", t = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path d="M25.84 31.58a.83.83 0 01-.62-.29L16 24.54l-9.22 6.75a.82.82 0 01-1.44-.53V1.24a.82.82 0 01.82-.82h19.68a.82.82 0 01.82.82v29.52a.82.82 0 01-.54.77.8.8 0 01-.28.05zM16 22.46a.82.82 0 01.62.29l8.4 5.8V2.06H7v26.48l8.4-5.8a.82.82 0 01.6-.28z"/>
  <path d="M13.4 19.31a.9.9 0 01-.63-.26l-3.59-3.59a.9.9 0 111.27-1.27l3 3 8.33-8.33A.9.9 0 0123 10.08l-9 9a.89.89 0 01-.63.26z"/>
</svg>
`, "image/svg+xml").firstChild;
  if (a.title) {
    const e = document.createElementNS(r, "title");
    e.textContent = a.title, t.appendChild(e);
  }
  const l = Array.from((t == null ? void 0 : t.attributes) ?? []).reduce((e, n) => ({
    ...e,
    [n.name]: n.value
  }));
  return i(
    "svg",
    {
      ...l,
      ...s.attrs,
      role: "img",
      innerHTML: t.innerHTML
    }
  );
};
export {
  m as default
};
//# sourceMappingURL=CheckIcon.CcHVV6hy.js.map
